'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactViewController = function () {
  function ContactViewController(authService, enums, contactService, loadingService, $stateParams, enquiryService, printService, mailService, $scope, $ngConfirm, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ContactViewController);
    if (!authService.validateUser(false, 'Contact', enums.PERMISSION_TYPE.View, true)) {
      return;
    }

    this.authService = authService;
    this.enums = enums;
    this.contactService = contactService;
    this.loadingService = loadingService;
    this.enquiryService = enquiryService;
    this.printService = printService;
    this.mailService = mailService;
    this.$scope = $scope;
    this.$ngConfirm = $ngConfirm;
    this.$state = $state;

    this.loadContact($stateParams.contactId);
  }

  (0, _createClass3.default)(ContactViewController, [{
    key: 'loadContact',
    value: function loadContact(contactId) {
      var ctrl = this;

      ctrl.loadingService.showLoading('viewContact', 'Loading Contact Details ...');

      ctrl.contactService.viewContact(ctrl.authService.authData.currentLocation.key, contactId).then(function (response) {
        ctrl.contact = response.data;
        ctrl.contact.enquiry = ctrl.parseRegs(ctrl.contact.enquiries);
        ctrl.contact.address = ctrl.formatAddress(ctrl.contact.address);
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching contacts." + (err.data ? err.data.messageDetail : '')
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('viewContact');
      });
    }
  }, {
    key: 'parseRegs',
    value: function parseRegs(data) {
      (0, _lodash.map)(data, function (item) {
        if (item.regs.length == 0) {
          item.hasRegs = false;
          item.regToShow = "N/A";
        } else if (item.regs.length == 1) {
          item.hasRegs = true;
          item.defaultRegId = item.regs[0].item1;
          item.regToShow = item.regs[0].item2;
        } else {
          item.hasRegs = true;
          item.regToShow = item.regs[0].item2;
          item.defaultRegId = item.regs[0].item1;
          item.regToShowExtra = '+ ' + (item.regs.length - 1) + ' more';
        }
      });

      return data;
    }
  }, {
    key: 'formatAddress',
    value: function formatAddress(address) {
      var addressString = address.line1;

      if (address.line2) {
        addressString += ', ' + address.line2;
      }

      if (address.line3) {
        addressString += ', ' + address.line3;
      }

      if (address.city) {
        addressString += ', ' + address.city;
      }

      if (address.country) {
        addressString += ', ' + address.country;
      }

      if (address.zip) {
        addressString += ', ' + address.zip;
      }

      return addressString;
    }
  }, {
    key: 'duplicate',
    value: function duplicate(enquiryId) {
      var ctrl = this;

      var sure = window.confirm("Are you sure you want to duplicate this enquiry ?");

      if (!sure) {
        return;
      }

      ctrl.loadingService.showLoading('viewContact', 'Duplicating Enquiry ...');

      ctrl.enquiryService.duplicate(enquiryId).then(function (response) {
        ctrl.contact.enquiries.unshift(response.data);
      }).finally(function () {
        ctrl.loadingService.hideLoading('viewContact');
      });
    }
  }, {
    key: 'printDpaHistory',
    value: function printDpaHistory() {
      this.printService.printDpaHistory(this.contact.contactId);
    }
  }, {
    key: 'mailDpaHistory',
    value: function mailDpaHistory() {
      var ctrl = this;

      ctrl.loadingService.showLoading('viewContact', 'Emailing DPA History ...');

      ctrl.mailService.mailDpaHistory(this.contact.contactId).then(function (response) {
        alert('Email sent successfully');
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching contacts." + (err.data ? err.data.messageDetail : '')
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('viewContact');
      });
    }
  }, {
    key: 'showExtraRegs',
    value: function showExtraRegs(regs) {
      this.$scope.regs = regs;
      this.$scope.goToVehicle = this.goToVehicle.bind(this);

      this.showMoreModal = this.$ngConfirm({
        title: 'All Vehicle Regs',
        type: 'green',
        contentUrl: 'templates/contact/contactViewEnquiryRegs',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          close: {
            text: 'Close',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'goToVehicle',
    value: function goToVehicle(vehicleId) {
      this.showMoreModal.close();
      this.$state.go('vehicleEdit', { vehicleId: vehicleId });
    }
  }]);
  return ContactViewController;
}();

exports.default = ContactViewController;


// WEBPACK FOOTER //
// ./client/app/components/contact/contactView/contactView.controller.js